import React, { useEffect } from 'react'
import Gap from './Gap'
import {
  acquireBottomImmersive,
  releaseBottomImmersive,
} from '../utils/flutterStatusBar'

interface ExistingRecordDialogProps {
  isOpen: boolean
  onEdit: () => void
  onNewVisit: () => void
  /** 배경을 눌러 닫았을 때. 아무것도 고르지 않은 것이다 */
  onDismiss: () => void
}

/**
 * 이미 기록한 곳에 다시 들어왔을 때 묻는 팝업.
 *
 * 왜 묻나
 * -------
 * 예전에는 같은 곳에 다시 기록하면 말없이 덮어썼다. 재방문을 여러 번 남길 수
 * 있게 된 지금은 "고치려는 것"과 "새로 남기려는 것"을 구별할 수 없으므로
 * 추측하지 않고 물어본다.
 *
 * 왜 '방문'이 아니라 '기록'인가
 * ----------------------------
 * 포장·배달도 기록 대상이라 '방문'이라고 하면 매장에 간 것만 남기라는 뜻으로
 * 읽힌다. 무엇을 했든 한 번의 경험을 남긴다는 의미로 '기록'을 쓴다.
 *
 * 다 찼을 때는 아예 안 뜬다
 * ----------------------
 * 기록이 상한까지 차면 '새로운 기록'을 만들 수 없어 고를 것이 없다.
 * 그때는 호출부(StoreReview)가 이 팝업을 열지 않고 바로 수정 화면을 연다.
 *
 * 배경 탭은 선택이 아니다
 * ----------------------
 * ConfirmDialog를 그대로 쓰지 않은 이유다. 거기선 배경 탭이 onCancel이라
 * '기록 수정'이 조용히 골라진다. 여기선 어느 쪽도 고르지 않은 것으로 본다.
 */
const ExistingRecordDialog: React.FC<ExistingRecordDialogProps> = ({
  isOpen,
  onEdit,
  onNewVisit,
  onDismiss,
}) => {
  // 센터 다이얼로그라 하단 SafeArea를 풀어 dim이 홈 인디케이터까지 덮게 한다
  useEffect(() => {
    if (!isOpen) return
    acquireBottomImmersive()
    return () => releaseBottomImmersive()
  }, [isOpen])

  if (!isOpen) return null

  return (
    <>
      <div
        className="fixed inset-0 z-[1070] bg-black bg-opacity-40"
        onClick={onDismiss}
      />

      <div className="fixed inset-0 z-[1070] flex items-center justify-center px-18px">
        <div
          className="w-full max-w-[333px] rounded-12px bg-white px-18px pt-24px pb-24px flex flex-col items-center"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="font-pretendard font-700 text-16px text-center text-brown-80%-main">
            이미 기록한 곳이에요
          </p>
          <Gap height={24} />

          <div className="w-full flex gap-8px">
            <button
              type="button"
              onClick={onEdit}
              className="flex-1 h-44px rounded-12px bg-472410-10% font-pretendard font-700 text-16px text-brown-80%-main flex items-center justify-center"
            >
              기록 수정
            </button>
            <button
              type="button"
              onClick={onNewVisit}
              className="flex-1 h-44px rounded-12px bg-brown-80%-main font-pretendard font-bold text-16px text-white flex items-center justify-center"
            >
              새로운 기록
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ExistingRecordDialog
